/**
 * @generated SignedSource<<e11661380a0408c29bdd76eb09acee63>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PageSettingsDeleteImageMutation$variables = {
  noteId: string;
  pageId: string;
};
export type PageSettingsDeleteImageMutation$data = {
  readonly note: {
    readonly page: {
      readonly removeImage: {
        readonly id: string;
        readonly image: {
          readonly id: string;
        } | null;
      };
    };
  };
};
export type PageSettingsDeleteImageMutation = {
  response: PageSettingsDeleteImageMutation$data;
  variables: PageSettingsDeleteImageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "noteId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "noteId"
      }
    ],
    "concreteType": "NoteMutation",
    "kind": "LinkedField",
    "name": "note",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "pageId"
          }
        ],
        "concreteType": "NotePageMutation",
        "kind": "LinkedField",
        "name": "page",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "WidgetNotePage",
            "kind": "LinkedField",
            "name": "removeImage",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "image",
                "plural": false,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PageSettingsDeleteImageMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PageSettingsDeleteImageMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "e797bbb0d95ede6938254cef83345f57",
    "id": null,
    "metadata": {},
    "name": "PageSettingsDeleteImageMutation",
    "operationKind": "mutation",
    "text": "mutation PageSettingsDeleteImageMutation(\n  $noteId: ID!\n  $pageId: ID!\n) {\n  note(id: $noteId) {\n    page(id: $pageId) {\n      removeImage {\n        id\n        image {\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "211a9af80f8a742c5a23d4302a581c6e";

export default node;
